import React from 'react';
import styled from 'styled-components';
import { BatteryIcon, SignalIcon, WifiIcon } from '../common/Icons';

const Bar = styled.div<{ $tone: 'light' | 'dark' }>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 13cqw;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.4cqw 7.5cqw 0 10cqw;
  z-index: 40;
  pointer-events: none;
  color: ${props => (props.$tone === 'light' ? '#fff' : '#000')};
  transition: color 0.4s ease;
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Text', 'Inter', sans-serif;

  svg {
    width: auto;
  }
`;

const Time = styled.span`
  font-size: 4.3cqw;
  font-weight: 600;
  letter-spacing: -0.02em;
`;

const Icons = styled.div`
  display: flex;
  align-items: center;
  gap: 1.4cqw;

  svg:nth-child(1) { height: 2.9cqw; }
  svg:nth-child(2) { height: 3cqw; }
  svg:nth-child(3) { height: 3.2cqw; }
`;

// 9:41 — the time Apple shows in every product shot.
const StatusBar: React.FC<{ tone?: 'light' | 'dark' }> = ({ tone = 'light' }) => (
  <Bar $tone={tone}>
    <Time>9:41</Time>
    <Icons>
      <SignalIcon />
      <WifiIcon />
      <BatteryIcon />
    </Icons>
  </Bar>
);

export default StatusBar;
